var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediumoffwhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1151 1151",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.45 576.26c0 163.67-131.78 296.35-294.33 296.35-162.55 0-294.34-132.68-294.34-296.35 0-163.67 131.78-296.36 294.34-296.36 162.56 0 294.33 132.69 294.33 296.36M1206.34 576.26c0 154.06-65.89 279-147.17 279-81.28 0-147.17-124.94-147.17-279s65.88-279 147.16-279 147.17 124.9 147.17 279M1338.41 576.26c0 138-23.17 249.94-51.76 249.94-28.59 0-51.75-111.91-51.75-249.94s23.17-249.94 51.75-249.94 51.76 111.9 51.76 249.94",
    transform: "translate(-246.226 -1.336)",
    fillRule: "nonzero",
    fill: "#f8f9fa",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1633.77 0h-296.29v.25H296.29V0H0v1150.07h119.51v.44h1410.41v-.44h103.85V0Zm-296.29 296.54v557.67H296.29V296.54h1041.19Z",
    transform: "translate(-246.226 -1.336)",
    fill: "none",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumoffwhite);
export default __webpack_public_path__ + "static/media/mediumoffwhite.3ba84da3fc62a3348794a81e5125744c.svg";
export { ForwardRef as ReactComponent };